import React from "react";
import { Row, Col } from "react-bootstrap";
import { Select, TextBox, Table, Button, Checkbox, IconPlus, IconMinus, IconListView, IconTrash, Tooltip, IconInfo, } from "@veneer/core";

export const showMaxCostPerImpression = ({
  t,
  specialConditionType,
  seriesList,
  oneShotDisabled,
  whiteDisabled,
  isLastTier,
  minPrint,
  maxPrint,
  blackCpp,
  otherCpp,
  oneShotCpp,
  whiteCpp,
  setMinPrint,
  setMaxPrint,
  setBlackCpp,
  setOtherCpp,
  setOneShotCpp,
  setWhiteCpp,
  setCompensationTable,
  compensationTable,
  setIsLastTier
}) => {
  const handleClick = () => {
    let obj = [...compensationTable];
    if (maxPrint === "") {
      alert(t("alertMaxCost1"));
    } else if (maxPrint < minPrint) {
      alert(t("alertMaxCost2") + minPrint + ".");
    } else if (
      (blackCpp > 0.99999999 || blackCpp === "") ||
      (otherCpp > 0.99999999 || otherCpp === "") ||
      ((oneShotCpp > 0.99999999 || oneShotCpp === "") && !oneShotDisabled) ||
      ((whiteCpp > 0.99999999 || whiteCpp === "") && !whiteDisabled)
    ) {
      alert(t("alertMaxCost3"));
    } else {
      obj.push({
        minPrint,
        maxPrint,
        blackCpp,
        otherCpp,
        oneShotCpp,
        whiteCpp,
      });
      setMinPrint(maxPrint + 1);
      setMaxPrint("");
      setBlackCpp("");
      setOtherCpp("");
      setOneShotCpp("");
      setWhiteCpp("");
      setCompensationTable(obj);
    }
  };

  const handleClickLess = () => {
    if (compensationTable.length === 0) return;
    let obj = [...compensationTable];
    obj.pop();
    setCompensationTable(obj);
    if (obj.length > 0) {
      let lastRemainingItem = obj[obj.length - 1];
      setMinPrint(Number(lastRemainingItem.maxPrint) + 1);
    } else setMinPrint(1);
  };

  const handleLast = () => {
    let obj = [...compensationTable];
    if (
      (blackCpp > 0.99999999 || blackCpp === "") ||
      (otherCpp > 0.99999999 || otherCpp === "") ||
      ((oneShotCpp > 0.99999999 || oneShotCpp === "") && !oneShotDisabled) ||
      ((whiteCpp > 0.99999999 || whiteCpp === "") && !whiteDisabled)
    ) {
      alert(t("alertMaxCost3"));
    } else {
      if (!(specialConditionType === 13)) {
        obj.push({
          minPrint,
          maxPrint: 999999999,
          blackCpp,
          otherCpp,
          oneShotCpp,
          whiteCpp,
        });
      } else {
        obj.push({
          minPrint,
          maxPrint: 999,
          blackCpp,
          otherCpp,
          oneShotCpp,
          whiteCpp,
        });
      }
      setMinPrint(1);
      setMaxPrint("");
      setBlackCpp("");
      setOtherCpp("");
      setOneShotCpp("");
      setWhiteCpp("");
      setCompensationTable(obj);
      setIsLastTier(true);
    }
  };

  if ( specialConditionType === 1 || specialConditionType === 13 || specialConditionType === 22 || specialConditionType === 23 || specialConditionType === 26 ) {
    return (
      <>
        {(seriesList.find((e) => e.globalaccount === true) && [26, 22].includes(specialConditionType)) ? null : (
          <>
            <br />
            <Row>
              <br />
              <Col md="12">
                <h4 style={{ marginLeft: "35%" }}>{t("bonus")} Maximum CPP</h4>
              </Col>
              <br />
              <Col xs="4" md="4">
                <TextBox
                  id="min-print"
                  label={specialConditionType === 13 ? "Min LS Mark" : t("bonustable.table1")}
                  maxLength="9"
                  value={minPrint}
                  disabled
                />
                <br />
                <TextBox
                  id="max-print"
                  label={specialConditionType === 13 ? "Max LS Mark" : t("bonustable.table2")}
                  maxLength="9"
                  value={maxPrint}
                  onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                  onChange={(e) => { if (e === "") setMaxPrint(""); else setMaxPrint(parseInt(e)); }}
                  disabled={isLastTier}
                />
                <br />
                <TextBox
                  id="black-cpp"
                  label={t("prices.blackcommprice")}
                  maxLength="10"
                  value={blackCpp}
                  onChange={(e) => { if (!isNaN(e)) setBlackCpp(e); }}
                  disabled={isLastTier}
                />
                <br />
                <TextBox
                  id="other-cpp"
                  label={t("prices.othercommprice")}
                  maxLength="10"
                  value={otherCpp}
                  onChange={(e) => { if (!isNaN(e)) setOtherCpp(e); }}
                  disabled={isLastTier}
                />
                <br />
                <TextBox
                  id="one-shot-cpp"
                  label={t("prices.oneshotcommprice")}
                  maxLength="10"
                  value={oneShotCpp}
                  onChange={(e) => { if (!isNaN(e)) setOneShotCpp(e); }}
                  disabled={isLastTier ? true : oneShotDisabled ? true : false}
                />
                <br />
                <TextBox
                  id="white-cpp"
                  label={t("prices.whitecommprice")}
                  maxLength="10"
                  value={whiteCpp}
                  onChange={(e) => { if (!isNaN(e)) setWhiteCpp(e); }}
                  disabled={isLastTier ? true : whiteDisabled ? true : false}
                />
                <br />
                <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                  <Button id="add-to-compensation-array" onClick={handleClick} leadingIcon={<IconPlus />} disabled={isLastTier}>
                    {t("addTier")}
                  </Button>
                  <Button id="less-to-compensation-array" onClick={handleClickLess} leadingIcon={<IconMinus />} disabled={isLastTier}>
                    {t("clearTier")}
                  </Button>
                  <Button id="last-compensation-array" onClick={handleLast} leadingIcon={<IconListView />} disabled={isLastTier}>
                    {t("lastTier")}
                  </Button>
                  <Button
                    id="clear-compensation-array"
                    appearance="secondary"
                    leadingIcon={<IconTrash />}
                    onClick={() => {
                      setCompensationTable([]);
                      setMinPrint(1);
                      setMaxPrint("");
                      setBlackCpp("");
                      setOtherCpp("");
                      setOneShotCpp("");
                      setWhiteCpp("");
                      setIsLastTier(false);
                    }}
                  >
                    {t("clearTable")}
                  </Button>
                  <br />
                  <br />
                </div>
              </Col>
              <Col xs="8" md="8">
                <Table
                  name="bonus-table"
                  columns={[
                    { id: "minPrint", label: specialConditionType === 13 ? "Min LS Mark %" : t("bonustable.table1") },
                    { id: "maxPrint", label: specialConditionType === 13 ? "Max LS Mark %" : t("bonustable.table2") },
                    { id: "blackCpp", label: t("prices.blackcommprice") },
                    { id: "otherCpp", label: t("prices.othercommprice") },
                    { id: "oneShotCpp", label: t("prices.oneshotcommprice") },
                    { id: "whiteCpp", label: t("prices.whitecommprice") },
                  ]}
                  data={compensationTable}
                />
                <br />
                <p>{t("memoMaxCost1")}
                  <ul style={{ marginLeft: "40px" }}>
                    <li><u>Indigo 1x000</u>: B2 (A3 <b>x 2</b>)</li>
                    <li><u>Indigo 20000</u>: B1 (A3 <b>x 4</b>)</li>
                    <li><u>Indigo 30000</u>: B2 (A3 <b>x 2</b>)</li>
                  </ul>
                </p>
                <br />
                <p>{t("memoMaxCost2")}
                  <ul style={{ marginLeft: "40px" }}>
                    <li><u>Indigo 1x000</u>: {t("memoMaxCost3")}</li>
                    <li><u>Indigo 20000 &amp; 30000</u>: {t("memoMaxCost4")}</li>
                  </ul>
                </p>
              </Col>
            </Row>
          </>
        )}
      </>
    );
  }

  return null;
};

export const showBonusSpecialTable = ({
  t,
  specialConditionType,
  minPrint,
  maxPrint,
  bonus,
  setMinPrint,
  setMaxPrint,
  setBonus,
  setBonusTable,
  bonusTable,
  setIsLastTier,
  isLastTier,
  setSpecialConditionType
}) => {
  const handleClick = () => {
    let obj = [...bonusTable];
    if (maxPrint < 0 || isNaN(maxPrint)) {
      alert(t("alertMaxCost1"));
    } else if (maxPrint < minPrint) {
      alert(t("alertMaxCost2"));
    } else if (bonus < 0 || isNaN(bonus)) {
      alert(t("alertBonus"));
    } else {
      obj.push({ minPrint, maxPrint, bonus });
      setMinPrint(maxPrint + 1);
      setMaxPrint("");
      setBonus("");
      setBonusTable(obj);
    }
  };

  const handleClickLess = () => {
    if (bonusTable.length === 0) return;
    let obj = [...bonusTable];
    obj.pop();
    setBonusTable(obj);
    if (obj.length > 0) {
      let lastRemainingItem = obj[obj.length - 1];
      setMinPrint(Number(lastRemainingItem.maxPrint) + 1);
    } else setMinPrint(1);
  };

  const handleLast = () => {
    let obj = [...bonusTable];
    if (!Math.sign(bonus) || bonus === "") {
      alert(t("alertBonus"));
    } else {
      obj.push({ minPrint, maxPrint: 999999999, bonus });
      setMinPrint("");
      setMaxPrint("");
      setBonus("");
      setBonusTable(obj);
      setIsLastTier(true);
    }
  };

  if ( specialConditionType === 2 || specialConditionType === 8 || specialConditionType === 12 || specialConditionType === 15 || specialConditionType === 17 ) {
    return (
      <Row>
        <Col xs="4" md="4">
          <TextBox
            id="min-print"
            label={t("bonustable.table1")}
            maxLength="9"
            value={minPrint}
            disabled
          />
          <br />
          <TextBox
            id="max-print"
            label={t("bonustable.table2")}
            maxLength="9"
            value={maxPrint}
            onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
            onChange={(e) => { if (e === "") setMaxPrint(""); else setMaxPrint(parseInt(e)); }}
            disabled={isLastTier}
          />
          <br />
          <TextBox
            id="bonus"
            label="Bonus %"
            maxLength="3"
            value={bonus}
            onKeyPress={(event) => { if (event.target.value.replace(/[^0-9]/g, "").length >= 2) event.preventDefault(); }}
            onChange={(e) => { if (!isNaN(e) || e === "-") setBonus(e); }}
            disabled={isLastTier}
          />
          <br />
          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            <Button id="add-to-bonus-array" onClick={handleClick} leadingIcon={<IconPlus />} disabled={isLastTier}>
              {t("addTier")}
            </Button>
            <Button id="less-to-compensation-array" onClick={handleClickLess} leadingIcon={<IconMinus />} disabled={isLastTier}>
              {t("clearTier")}
            </Button>
            <Button id="last-bonus-array" onClick={handleLast} leadingIcon={<IconListView />} disabled={isLastTier}>
              {t("lastTier")}
            </Button>
            <Button
              id="clear-bonus-array"
              appearance="secondary"
              leadingIcon={<IconTrash />}
              onClick={() => {
                setBonusTable([]);
                setMinPrint(1);
                setMaxPrint("");
                setBonus("");
                setIsLastTier(false);
              }}
            >
              {t("clearTable")}
            </Button>
            <br />
            <br />
          </div>
        </Col>
        <Col xs="8" md="8">
          <Table
            name="bonus-table"
            columns={[
              { id: "minPrint", label: t("bonustable.table1") },
              { id: "maxPrint", label: t("bonustable.table2") },
              { id: "bonus", label: "Bonus" },
            ]}
            data={bonusTable}
          />
          <br />
          <Col xs="8" md="8">
            <br />
            <Checkbox
              id="epm-bonus-table"
              label="EPM"
              defaultChecked={specialConditionType === 12 || specialConditionType === 17}
              onChange={() => {
                if (specialConditionType === 2) setSpecialConditionType(12);
                else if (specialConditionType === 12) setSpecialConditionType(2);
                else if (specialConditionType === 8) setSpecialConditionType(17);
                else if (specialConditionType === 17) setSpecialConditionType(8);
              }}
            />
            <br />
            <Checkbox
              id="combine-clicks-fixed-bonus"
              label="Combine Clicks with other client"
              defaultChecked={specialConditionType === 8 || specialConditionType === 17}
              onChange={() => {
                if (specialConditionType === 2) setSpecialConditionType(8);
                else if (specialConditionType === 8) setSpecialConditionType(2);
                else if (specialConditionType === 12) setSpecialConditionType(17);
                else if (specialConditionType === 17) setSpecialConditionType(12);
              }}
            />
          </Col>
        </Col>
      </Row>
    );
  }

  return null;
};

export const showBonusLSDiscount = ({
  t,
  specialConditionType,
  lowCoverage,
  bonusLSDiscount,
  bonusLSDiscountSend,
  minPrintLS,
  maxPrintLS,
  bonusLS,
  setBonusLSDiscount,
  setBonusLSDiscountSend,
  setMinPrintLS,
  setMaxPrintLS,
  setBonusLS,
  setIsAddOneMin,
  setIsLastTierLS,
  isLastTierLS,
  isAddOneMin
}) => {
  const handleClick = () => {
    let obj = [...bonusLSDiscount];
    let objSend = [...bonusLSDiscountSend];
    if (maxPrintLS < 0 || isNaN(maxPrintLS) || minPrintLS < 0 || isNaN(minPrintLS)) {
      alert(t("alertMaxCost1"));
    } else if (maxPrintLS < minPrintLS) {
      alert(t("alertMaxCost2"));
    } else if (isNaN(bonusLS)) {
      alert(t("alertBonus"));
    } else {
      obj.push({ minPrint: minPrintLS, maxPrint: maxPrintLS, bonus: `${bonusLS} %` });
      setMinPrintLS(parseInt(maxPrintLS) + 1);
      setMaxPrintLS("");
      setBonusLS("");
      setBonusLSDiscount(obj);
      objSend.push({ InitialLSMark: minPrintLS, FinalLSMark: maxPrintLS, Discount: bonusLS });
      setBonusLSDiscountSend(objSend);
      setIsAddOneMin(true);
    }
  };

  const handleClickLess = () => {
    if (bonusLSDiscount.length === 0) return;
    let obj = [...bonusLSDiscount];
    obj.pop();
    setBonusLSDiscount(obj);
    if (obj.length > 0) {
      let lastRemainingItem = obj[obj.length - 1];
      setMinPrintLS(Number(lastRemainingItem.maxPrint) + 1);
    } else setMinPrintLS(1);

    if (bonusLSDiscountSend.length === 0) return;
    let objSend = [...bonusLSDiscountSend];
    objSend.pop();
    setBonusLSDiscountSend(objSend);
  };

  const handleLast = () => {
    let obj = [...bonusLSDiscount];
    let objSend = [...bonusLSDiscountSend];
    if (isNaN(bonusLS) || bonusLS === "") {
      alert(t("alertBonus"));
    } else {
      obj.push({ minPrint: minPrintLS, maxPrint: 9999, bonus: `${bonusLS} %` });
      setMinPrintLS("");
      setMaxPrintLS("");
      setBonusLS("");
      setBonusLSDiscount(obj);
      objSend.push({ InitialLSMark: minPrintLS, FinalLSMark: 9999, Discount: bonusLS });
      setBonusLSDiscountSend(objSend);
      setIsLastTierLS(true);
    }
  };

  if (specialConditionType === 22 || (specialConditionType === 23 && lowCoverage)) {
    return (
      <Row>
        <br />
        <Col md="12">
          <h4 style={{ marginLeft: "35%" }}>{t("bonus")} LSMark</h4>
        </Col>
        <br />
        <Col xs="4" md="4">
          <TextBox
            id="min-print"
            label={t("InitialLSMark")}
            maxLength="4"
            value={minPrintLS}
            onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) event.preventDefault();
            }}
            onChange={(e) => {
              if (e === "") setMinPrintLS("");
              else setMinPrintLS(parseInt(e));
            }}
            disabled={isLastTierLS ? true : isAddOneMin}
          />
          <br />
          <TextBox
            id="max-print"
            label={t("EndLSMark")}
            maxLength="4"
            value={maxPrintLS}
            onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) event.preventDefault();
            }}
            onChange={(e) => {
              if (e === "") setMaxPrintLS("");
              else setMaxPrintLS(parseInt(e));
            }}
            disabled={isLastTierLS}
          />
          <br />
          <TextBox
            id="bonus"
            label={t("bonus") + " %"}
            maxLength="5"
            value={bonusLS}
            onKeyPress={(event) => {
              if (event.target.value.replace(/[^0-9]/g, "").length >= 2) event.preventDefault();
            }}
            onChange={(e) => {
              if (!isNaN(e) || e === "-") setBonusLS(e);
            }}
            disabled={isLastTierLS}
          />
          <br />
          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            <Button id="add-to-bonus-array" onClick={handleClick} leadingIcon={<IconPlus />} disabled={isLastTierLS}>
              {t("addTier")}
            </Button>
            <Button id="less-to-compensation-array" onClick={handleClickLess} leadingIcon={<IconMinus />} disabled={isLastTierLS}>
              {t("clearTier")}
            </Button>
            <Button id="last-bonus-array" onClick={handleLast} leadingIcon={<IconListView />} disabled={isLastTierLS}>
              {t("lastTier")}
            </Button>
            <Button
              id="clear-bonus-array"
              appearance="secondary"
              leadingIcon={<IconTrash />}
              onClick={() => {
                setBonusLSDiscount([]);
                setBonusLSDiscountSend([]);
                setMinPrintLS(1);
                setMaxPrintLS("");
                setBonusLS("");
                setIsLastTierLS(false);
                setIsAddOneMin(false);
              }}
            >
              {t("clearTable")}
            </Button>
            <br />
            <br />
          </div>
        </Col>
        <Col xs="8" md="8">
          <Table
            name="bonus-table"
            columns={[
              { id: "minPrint", label: t("InitialLSMark") },
              { id: "maxPrint", label: t("EndLSMark") },
              { id: "bonus", label: t("bonus") },
            ]}
            data={bonusLSDiscount}
          />
        </Col>
      </Row>
    );
  }

  return null;
};

export const showRunLength = ({
  t,
  specialConditionType,
  segmentSelected,
  minimumImp,
  setMinimumImp,
  series,
  percentage,
  setPercentage,
  MinimumPrint,
  setMinimumPrint
}) => {
  if (specialConditionType === 21) {
    return (
      <Row>
        <Col xs="4" md="4">
          <TextBox
            label="Minimum Print"
            value={MinimumPrint}
            maxLength="9"
            onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) event.preventDefault();
            }}
            onChange={(e) => {
              if (!isNaN(e)) setMinimumPrint(e);
            }}
          />
        </Col>

        {segmentSelected === "L&P" ? (
          <Col xs="4" md="4">
            <Select
              id="minimun_metters"
              label={t("minimumMetters") + " L&P*"}
              value={minimumImp === 0 ? "" : [minimumImp]}
              options={[
                { value: 2000, label: t("minimumMetters") + " - 2,000" },
                { value: 3000, label: t("minimumMetters") + " - 3,000" },
                { value: 3500, label: t("minimumMetters") + " - 3,500" },
                { value: 5000, label: t("minimumMetters") + " - 5,000" },
                { value: 7500, label: t("minimumMetters") + " - 7,500" },
                { value: 10000, label: t("minimumMetters") + " - 10,000" },
                { value: 12500, label: t("minimumMetters") + " - 12,500" },
                { value: 15000, label: t("minimumMetters") + " - 15,000" },
              ]}
              onChange={(e) => {
                setMinimumImp(e.value);
              }}
              clearIcon={false}
            />
          </Col>
        ) : (
          <Col xs="4" md="4">
            <Select
              id="minimun_sheets"
              label={t("minimumSheets") + " GCP*"}
              value={minimumImp === 0 ? "" : [minimumImp]}
              options={[
                { value: 2000, label: t("minimumSheets") + " - 2,000" },
                { value: 2500, label: t("minimumSheets") + " - 2,500" },
                { value: 3000, label: t("minimumSheets") + " - 3,000" },
                { value: 4000, label: t("minimumSheets") + " - 4,000" },
                { value: 5000, label: t("minimumSheets") + " - 5,000" },
                { value: 6000, label: t("minimumSheets") + " - 6,000" },
                { value: 7000, label: t("minimumSheets") + " - 7,000" },
              ]}
              onChange={(e) => {
                setMinimumImp(e.value);
              }}
              clearIcon={false}
            />
          </Col>
        )}

        {series === 3 ? (
          <Col xs="4" md="4">
            <TextBox
              id="bonus_persentage"
              label={t("bonusPercentageRL") + " *"}
              maxLength="3"
              value={percentage || ""}
              onKeyPress={(event) => {
                if (event.target.value.replace(/[^0-9]/g, "").length >= 2) event.preventDefault();
              }}
              onChange={(e) => {
                if (!isNaN(e) || e === "-") setPercentage(e);
              }}
            />
          </Col>
        ) : (
          <Col xs="4" md="4">
            <TextBox
              id="bonus_persentage"
              label={t("committedPPIRL") + " *"}
              maxLength="9"
              value={percentage || ""}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) event.preventDefault();
              }}
              onChange={(e) => {
                if (!isNaN(e)) setPercentage(e);
              }}
            />
            *{"(" + t("valueCaptureNativeFormat") + ")"}
          </Col>
        )}
      </Row>
    );
  }

  return null;
};

export const showFixedBonus = ({
  t,
  specialConditionType,
  seriesList,
  oneShotDisabled,
  whiteDisabled,
  percentage,
  minimumImp,
  setPercentage,
  setMinimumImp
}) => {
  let lowCoverageDiscount = [];
  let discontSpecial6kPlus = [];

  if (specialConditionType === 23) {
    if (seriesList.find((e) => e.globalaccount === true)) {
      lowCoverageDiscount = [
        { value: 5, label: "5%" },
        { value: 10, label: "10%" },
        { value: 15, label: "15%" },
        { value: 20, label: "20%" },
      ];
    } else {
      lowCoverageDiscount = [
        { value: 5, label: "5%" },
        { value: 10, label: "10%" },
        { value: 15, label: "15%" },
      ];
    }
  }

  if (specialConditionType === 3 || specialConditionType === 14) {
    if (true) {
      discontSpecial6kPlus = [
        { value: 5, label: "1 Tier Up - 5%" },
        { value: 10, label: "2 Tiers Up - 10%" },
        { value: 15, label: "3 Tiers Up - 15%" },
        { value: 20, label: "4 Tiers Up - 20%" },
        { value: 25, label: "5 Tiers Up - 25%" },
        { value: 30, label: "6 Tiers Up - 30%" },
        { value: 35, label: "7 Tiers Up - 35%" },
        { value: 40, label: "8 Tiers Up - 40%" },
      ];
    }
  }

  if (specialConditionType === 3 || specialConditionType === 14 || specialConditionType === 23 || specialConditionType === 25) {
    return (
      <Row>
        {(specialConditionType === 3 || specialConditionType === 14) ? (
          <>
            <Col xs="4" md="4">
              <Select
                id="fixed-bonus"
                label="Fixed Bonus %"
                value={[percentage]}
                options={[
                  { value: 5, label: "5%" },
                  { value: 10, label: "10%" },
                  { value: 15, label: "15%" },
                  { value: 20, label: "20%" },
                  { value: 25, label: "25%" },
                  { value: 30, label: "30%" },
                ]}
                onChange={(e) => setPercentage(e.value)}
                onClear={() => setPercentage()}
              />
            </Col>
            <Col xs="4" md="4">
              <TextBox
                id="minimum-impressions"
                label={t("bonustable.table1")}
                value={minimumImp}
                maxLength="9"
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) event.preventDefault();
                }}
                onChange={(e) => {
                  if (!isNaN(e)) setMinimumImp(e);
                }}
              />
            </Col>
            <Col xs="4" md="4">
              <Checkbox
                id="epm-fixed-bonus"
                name="epm-fixed-bonus"
                label="EPM"
                defaultChecked={specialConditionType === 14}
                onChange={(e) => {
                  if (specialConditionType === 3) {
                    // no-op here, leave as original behavior if you later want to toggle type
                  }
                }}
              />
            </Col>
          </>
        ) : specialConditionType === 23 ? (
          <>
            <br />
            <Col md="12">
              <h4> {t("bonus")} Low Coverage </h4>
            </Col>
            <br />
            <Col xs="4" md="4">
              <Select
                id="fixed-bonus2"
                label="Percentage discount %"
                value={[percentage]}
                options={lowCoverageDiscount}
                onChange={(e) => setPercentage(e.value)}
                onClear={() => setPercentage()}
              />
            </Col>
            <Col xs="4" md="4">
              <TextBox
                id="minimum-impressions2"
                label="Coverage Below %"
                maxLength="9"
                value={minimumImp}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) event.preventDefault();
                }}
                onChange={(e) => {
                  if (!isNaN(e)) setMinimumImp(e);
                }}
              />
            </Col>
          </>
        ) : (
          <>
            <br />
            <Col md="12">
              <h4> {t("bonus")} Frame Width </h4>
            </Col>
            <br />
            <Col xs="4" md="4">
              <Select
                id="fixed-bonus2"
                label="Percentage discount %"
                value={[percentage]}
                options={[
                  { value: 4, label: "4%" },
                  { value: 5, label: "5%" },
                  { value: 6, label: "6%" },
                  { value: 7, label: "7%" },
                  { value: 8, label: "8%" },
                ]}
                onChange={(e) => setPercentage(e.value)}
                onClear={() => setPercentage()}
              />
            </Col>
            <Col xs="4" md="4">
              <TextBox
                id="minimum-impressions2"
                label="Coverage Below (mm)"
                value={minimumImp}
                maxLength="3"
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) event.preventDefault();
                }}
                onChange={(e) => {
                  if (!isNaN(e) && e <= 660) setMinimumImp(e);
                }}
              />
            </Col>
          </>
        )}
        <br /> <br />
      </Row>
    );
  }

  return null;
};

export const showCombineClicks = ({
  t,
  specialConditionType,
  channelCombineClicks,
  endUserListCombineClicks,
  endUserCombineClicks,
  endUserNameCombine,
  setEndUserNameCombine,
  setEndUserCombineClicks,
  setCombineClicksList,
  combineClicksList,
  channelList
}) => {
  const handleClick = () => {
    let obj = [...combineClicksList];
    obj.push({
      channelCombineClicks: channelCombineClicks,
      endUserCombineClicks: endUserCombineClicks,
      endUserName: endUserNameCombine,
    });
    setCombineClicksList(obj);
    setEndUserCombineClicks("");
  };

  const handleClear = () => {
    setCombineClicksList([]);
  };

  if (specialConditionType === 7 || specialConditionType === 8 || specialConditionType === 17) {
    return (
      <div>
        <Row>
          <Col xs="4" md="4">
            <Select
              id="channel-list-combine"
              label={t("channel")}
              options={channelList}
              value={channelCombineClicks ? [channelCombineClicks] : []}
              disabled
            />
          </Col>
          <Col xs="4" md="4">
            <Select
              id="end-user-list-combine"
              label={t("endUser")}
              options={endUserListCombineClicks}
              value={endUserCombineClicks ? [endUserCombineClicks] : []}
              placeholder={endUserCombineClicks}
              onChange={(e) => {
                setEndUserNameCombine(e.label);
                setEndUserCombineClicks(e.value);
              }}
              onClear={() => {
                setEndUserCombineClicks("");
              }}
            />
          </Col>
          <Col xs="4" md="4">
            <Button id="add-combine-clicks" leadingIcon={<IconPlus />} onClick={handleClick}>
              {t("addCombineClicks")}
            </Button>
          </Col>
        </Row>
        <Row>
          <Col xs="12" md="12">
            <br />
            <Table
              name="bonus-table"
              columns={[
                { id: "endUserCombineClicks", label: t("endUserId") },
                { id: "endUserName", label: t("endUser") },
              ]}
              data={combineClicksList}
            />
          </Col>
          <Col xs="4" md="4">
            <br />
            <Button
              id="clear-combine-clicks"
              appearance="secondary"
              leadingIcon={<IconTrash />}
              onClick={handleClear}
            >
              {t("clearCombineClicks")}
            </Button>
          </Col>
        </Row>
      </div>
    );
  }

  return null;
};

export const showTiersUp = ({
  t,
  specialConditionType,
  percentage,
  minimumImp,
  setPercentage,
  setMinimumImp
}) => {
  if (specialConditionType === 4 || specialConditionType === 19) {
    return (
      <Row>
        <Col xs="4" md="4">
          <Select
            id="tiers-up"
            label="Tiers Up %"
            value={[percentage]}
            options={[
              { value: 5, label: "1 Tier Up - 5%" },
              { value: 10, label: "2 Tiers Up - 10%" },
              { value: 15, label: "3 Tiers Up - 15%" },
            ]}
            onChange={(e) => {
              setPercentage(e.value);
            }}
            onClear={() => {
              setPercentage();
            }}
          />
        </Col>
        <Col xs="4" md="4">
          <TextBox
            id="minimum-impressions"
            label={t("bonustable.table1")}
            value={minimumImp}
            maxLength="9"
            onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) event.preventDefault();
            }}
            onChange={(e) => {
              if (!isNaN(e)) setMinimumImp(e);
            }}
          />
        </Col>
      </Row>
    );
  }

  return null;
};

export const showMinumimDiscount = ({
  t,
  specialConditionType,
  minumimDiscount,
  setMinumumDiscount
}) => {
  if (specialConditionType === 11) {
    return (
      <Row>
        <Col xs="4" md="4">
          <TextBox
            id="minimum-discount"
            label="Minumum Discount %"
            value={minumimDiscount}
            maxLength="3"
            onKeyPress={(event) => {
              if (event.target.value.replace(/[^0-9]/g, "").length >= 2) event.preventDefault();
            }}
            onChange={(e) => {
              if (!isNaN(e) || e === "-") setMinumumDiscount(e);
            }}
          />
        </Col>
      </Row>
    );
  }

  return null;
};

